import { Box } from '@zillow/constellation-10';

import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';

import { useIdentityVerification } from '../../hooks/useIdentityVerification';

import { getBannerContent } from './content';
import IdentityVerificationAlert from './IdentityVerificationAlert';

/**
 * The page banner's message, inline next to the publish action for wizard views, where the page banner
 * is hidden. Never dismissible: it explains why publishing is blocked.
 */
type PublishAlertProps = {
  /** Match the stack of Alerts it sits in. */
  marginBottom?: 'default' | 'loose';
};

const PublishAlert = ({ marginBottom = 'default' }: PublishAlertProps) => {
  const verification = useIdentityVerification();
  const { entry, restrictedActions, isEnforced } = verification;

  // The grace-period notice counts: it warns that publishing is about to be blocked.
  const isPublishAffected =
    restrictedActions.includes('PUBLISH_LISTING') || (entry?.status === 'NOT_STARTED' && !isEnforced);
  const content = isPublishAffected ? getBannerContent(verification, Date.now()) : undefined;

  if (!content) return null;

  return (
    <Box css={{ marginBottom }}>
      <IdentityVerificationAlert content={content} testId="IdentityVerificationPublishAlert" />
    </Box>
  );
};

const IdentityVerificationPublishAlert = (props: PublishAlertProps) => (
  <RpErrorBoundary fallback={<></>}>
    <PublishAlert {...props} />
  </RpErrorBoundary>
);

export default IdentityVerificationPublishAlert;
